module.exports = __webpack_public_path__ + "img/icon_finance.2cdc462.svg";